export type ErrorType = 'noActiveRequests' | 'network' | 'generic';

export const getErrorType = (error: unknown): ErrorType => {
  if (error instanceof NoActiveRequestsApiError) return 'noActiveRequests';
  if (error instanceof NetworkApiError) return 'network';
  return 'generic';
};
export class NoActiveRequestsApiError extends Error {
  constructor(message = 'No active requests found') {
    super(message);
    this.name = 'NoActiveRequestsApiError';
  }
}

export class NetworkApiError extends Error {
  constructor(message = 'Network request failed') {
    super(message);
    this.name = 'NetworkApiError';
  }
}
